// src/components/netseg/NetworkSegLessons.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useNetworkSeg } from "./NetworkSegLayout";
import LessonCard from "./netsegcomp/LessonCard";

const NetworkSegLessons = () => {
  const { lessons, userProgress } = useNetworkSeg();

  return (
    <div className="all-lessons-page">
      <div className="lessons-header">
        <h1>All Network Segmentation Lessons</h1>
        <p className="subtitle">
          {userProgress.completed_lessons.length} of {lessons.length} lessons
          completed
        </p>
      </div>

      <div className="lessons-grid">
        {lessons.map((lesson) => (
          <LessonCard
            key={lesson.id}
            lesson={lesson}
            isCompleted={userProgress.completed_lessons.includes(lesson.id)}
          />
        ))}
      </div>

      <div className="back-to-dashboard">
        <Link to="/netseg" className="btn btn-outline">
          ← Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NetworkSegLessons;
